import {UserResponse} from "../api-client";

export const bitwiseOr = (roleValues: number[]) => {
    let rolesDisjunction = 0;

    // Traverse the array compute AND
    for (const roleValue of roleValues) {
        rolesDisjunction = ( rolesDisjunction | roleValue );
    }

    return rolesDisjunction;
}
export function isAccessibleFor(principal: UserResponse | undefined, accessibilityRolesSum: number): boolean {
    if(!principal) {
        return false;
    }
    const role = accessibilityRoles[principal.role!];
    return (role & accessibilityRolesSum) === role;
}

export function isNotAccessibleFor(principal: UserResponse | undefined, accessibilityRolesSum: number): boolean {
    if(!principal) {
        return false;
    }
    const role = accessibilityRoles[principal.role!];

    return (role & ~accessibilityRolesSum) === role;
}

export const accessibilityRoles = {
    PATIENT: 1,
    RECEPTIONIST: 2,
    MEDICAL_ASSISTANT: 4,
    MEDICAL_DOCTOR: 8,
    CLINIC_ADMIN: 16,
    PLATFORM_ADMINISTRATOR: 32,
    DENTAL_TECHNICIAN: 64,
}